// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@steiner/Overrides/Widgets/Cart/CartLineCardExpanded";
import CutIcon from "@steiner/XDL/Icons/CutIcon";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.configurationGridItem = {
    ...cartLineSharedStyles.configurationContainer,
};

cartLineCardExpandedStyles.configurationOptionText = {
    ...cartLineSharedStyles.configurationOptionText,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        align-self: baseline;
        width: auto;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeGridItem = {
    ...cartLineSharedStyles.costCodeGridItem,
};

cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    ...cartLineSharedStyles.cartLineErrorMessageGridItem,
};

cartLineCardExpandedStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

cartLineCardExpandedStyles.cartLineNotes = {
    wrapper: {
        css: css`
            width: auto;
            ${xScreen("lte", "md")} {
                width: fit-content;
            }
            ${xScreen("lte", "xs")} {
                width: auto;
            }
        `,
    },
    linksWrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                gap: 24px;
            }
            ${xScreen("lte", "xs")} {
                gap: 10px;
            }
        `,
    },
};

cartLineCardExpandedStyles.extendedUnitNetPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        ${xScreen("lt", "sm")} {
            align-items: end;
        }
    `,
};

cartLineCardExpandedStyles.costCodeSelect = {
    cssOverrides: {
        formField: css`
            width: 200px;
        `,
    },
};

cartLineCardExpandedStyles.quantity = {
    editableQuantityTextField: {
        errorProps: {
            mergeCss: true,
            css: css`
                width: 150px;
            `,
        },
        labelText: {
            css: css`
                ${xScreen("gt", "md")} {
                    display: none;
                }

                @media print {
                    &&& {
                        display: block;
                        font-size: 14px;
                        line-height: 16px;
                        padding-left: 40px;
                    }
                }
            `,
        },
        container: {
            css: css`
                @media print {
                    &&&& {
                        &,
                        input {
                            background: ${color("common.background")};
                        }
                    }
                }
            `,
        },
    },
};

cartLineCardExpandedStyles.tooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

cartLineCardExpandedStyles.tooltipContentContainer = {
    css: css`
        display: flex;
        gap: 4px;
        margin-top: 8px;
    `,
};

cartLineCardExpandedStyles.tooltipIcon = {
    src: AlertTriangle,
    size: 12,
    color: "warning",
};

cartLineCardExpandedStyles.tooltipContentText = {
    size: 10,
    lineHeight: "12px",
};

cartLineCardExpandedStyles.priceNotAvailable = {
    size: 14,
    lineHeight: "22px",
};

cartLineCardExpandedStyles.promotionIcon = {
    ...cartLineSharedStyles.promotionIcon,
};

cartLineCardExpandedStyles.addCutLengthsLink = {
    ...mergeWithCss(cartLineSharedStyles.cartLineNotes?.addToProjectsLink, {
        icon: {
            iconProps: {
                src: CutIcon,
            },
        },
        css: css`
            margin-top: 10px;
            ${xScreen("lte", "md")} {
                margin-top: 0;
                height: fit-content;
            }
            ${xScreen("lte", "xs")} {
                margin-left: auto;
            }
        `,
    }),
};

cartLineCardExpandedStyles.notesWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
            gap: 24px;
        }
        ${xScreen("lte", "xs")} {
            gap: 10px;
            ${({ showAddToProjectsLink }: any) =>
                showAddToProjectsLink &&
                css`
                    flex-direction: column;
                `}
        }
    `,
};
